/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Agenda_Show_AllInputs */



/**
* | output |
* | --- |
* | "Show all events" |
*
* @param {Tournaments_Agenda_Show_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_agenda_show_all = /** @type {((inputs?: Tournaments_Agenda_Show_AllInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Agenda_Show_AllInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher tous les événements")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar todos los eventos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mostrar todos os eventos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra tutti gli eventi")
	return /** @type {LocalizedString} */ ("Show all events")
});